export const NO_BREAK_SPACE = '\u00A0';

const unbreakableSpaces = (word: string) => word.replace(/ /g, NO_BREAK_SPACE);

export default unbreakableSpaces;
